module.exports = __webpack_public_path__ + "img/food3.347c465f.png";